module.exports = __webpack_public_path__ + "assets/4055a3010f3ac1791495f2e4a411bd6b.mp3";